/**
 * Cross-cutting applier helpers.
 *
 * Rules (from CLAUDE.md + spec §12):
 * - version MUST increment by exactly 1 per accepted action.
 * - Input state is NEVER mutated — return a new GameState.
 * - No I/O, no Math.random().
 */

import type { GameState } from "../types/game-state";

/**
 * Returns a partial GameState override that bumps `version` by 1.
 * Every applier spreads this into their returned state.
 */
export const bumpVersion = (state: GameState): Pick<GameState, "version"> => ({
  version: state.version + 1,
});
